// GDACS time helpers. GDACS sends ISO strings without a zone and short
// "DD/MM HH:mm" labels, both in UTC and both without a year.

const HALF_YEAR_MS = 183 * 24 * 3600 * 1000;

// '2026-10-09T06:00:00' has no zone; a bare Date.parse would read it as LOCAL time.
export const parseGdacsIsoUtc = (s) => {
  if (!s || typeof s !== 'string') return null;
  const ms = Date.parse(/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? s : `${s}Z`);
  return Number.isFinite(ms) ? ms : null;
};

const LABEL_RE = /^(\d{2})\/(\d{2})\s+(\d{2}):(\d{2})(?:\s*UTC)?$/;

// 'DD/MM HH:mm' | 'DD/MM HH:mm UTC' -> epoch ms. The year is the one that puts the
// result closest to anchorMs (handles a forecast crossing New Year).
export function parseGdacsLabelTime(label, anchorMs) {
  if (typeof label !== 'string') return null;
  const m = LABEL_RE.exec(label.trim());
  if (!m) return null;
  const [dd, mm, hh, mi] = [m[1], m[2], m[3], m[4]].map(Number);
  if (mm < 1 || mm > 12 || dd < 1 || dd > 31 || hh > 23 || mi > 59) return null;
  const anchor = Number.isFinite(anchorMs) ? anchorMs : Date.now();
  let y = new Date(anchor).getUTCFullYear();
  let c = Date.UTC(y, mm - 1, dd, hh, mi);
  if (c - anchor > HALF_YEAR_MS) y -= 1;
  else if (anchor - c > HALF_YEAR_MS) y += 1;
  c = Date.UTC(y, mm - 1, dd, hh, mi);
  // Date.UTC rolls 31/02 into March; reject labels that did not round-trip.
  const d = new Date(c);
  if (!Number.isFinite(c) || d.getUTCDate() !== dd || d.getUTCMonth() !== mm - 1) return null;
  return c;
}

const pad2 = (n) => String(n).padStart(2, '0');

// -> 'Sun 11 · 06:00 UTC'
export function formatUtcLabel(timeMs, weekdays) {
  const d = new Date(timeMs);
  return `${weekdays[d.getUTCDay()]} ${d.getUTCDate()} · ${pad2(d.getUTCHours())}:${pad2(d.getUTCMinutes())} UTC`;
}

// -> '08 Oct' / '08 Oct 21:14 UTC' (UTC, locale-aware month name)
export function formatUtcDate(timeMs, locale = 'en') {
  const d = new Date(timeMs);
  const month = new Intl.DateTimeFormat(locale, { month: 'short', timeZone: 'UTC' }).format(d);
  return `${pad2(d.getUTCDate())} ${month}`;
}

export function formatUtcDateTime(timeMs, locale = 'en') {
  const d = new Date(timeMs);
  return `${formatUtcDate(timeMs, locale)} ${pad2(d.getUTCHours())}:${pad2(d.getUTCMinutes())} UTC`;
}

export const DAY_MS = 86_400_000;
export const utcDay = (ms) => Math.floor(ms / DAY_MS);

// 'DD/HH:mm' vertex label, UTC, no 'UTC' suffix (printed once elsewhere).
export function formatVertexLabel(timeMs) {
  const d = new Date(timeMs);
  return `${pad2(d.getUTCDate())}/${pad2(d.getUTCHours())}:${pad2(d.getUTCMinutes())}`;
}
